<template>
	<div class="home-flow">
		<transition name="van-fade">
			<CScrollPro
				v-if="configInitDone"
				ref="scrollRef"
				pullDown
				@pull-down="scrollPullDown"
				@scroll="wrapperScroll"
			>
				<div ref="contentBlockRef" class="content-block">
					<BannerFall />

					<div class="wf-base-overview wf-wrap-padding">
						<BrandFlowOverview />

						<SmartDisplayC v-if="!hideModule && moduleIsPublish('quote')" compId="quote" mode="overview" />

						<OverviewActivity v-if="moduleIsPublish('investment_activity')"></OverviewActivity>
					</div>

					<div v-if="!hideModule && moduleIsPublish('customs_calendar')" class="wf-card-wrap wf-wrap-padding">
						<OverviewCalendar></OverviewCalendar>
					</div>

					<div v-if="moduleIsPublish('news') && !isYili" class="wf-card-wrap wf-wrap-padding">
						<OverviewNews :newsList="newsList"></OverviewNews>
					</div>
					<div v-if="!hideModule && moduleIsPublish('shareholder')" class="wf-card-wrap wf-wrap-padding">
						<OverviewShareholder :stockholderInfo="stockholderInfo"></OverviewShareholder>
					</div>

					<div class="wf-footer-hr"></div>
					<div ref="obPlaceholder" v-if="tabList.length" class="wf-footer-list">
						<div
							class="wf-tab-placeholder"
							:style="{
								'height': placeholderHeight + 'px'
							}"
						></div>
						<CTeleport to=".footer-teleport-block" :disabled="teleportDisabled">
							<div ref="teleportWrapper" class="wf-tab-teleport">
								<div v-if="tabList.length" ref="verticalWrap" class="tab-sticky-wrapper">
									<div class="tab-sticky-box">
										<div
											v-for="(item, index) in tabList"
											:key="index"
											class="tab-sticky-item"
											:class="{
												'tab-sticky-item--active': footerActionTabId === item.moduleId
											}"
											@click="toggleFooterTab(item)"
										>
											<div class="tab-sticky-value">{{ item.name }}</div>
										</div>
									</div>
								</div>
								<div v-if="actionFilter.length > 1" class="wf-filter-wrap">
									<div
										v-for="(item, index) in actionFilter"
										:key="index"
										class="wf-filter-item"
										:class="{
											'wf-filter-item--active': actionFilterValue === item.value
										}"
										@click="handleFilterCheck(item.value)"
									>
										<span>{{ item.text }}</span>
									</div>
								</div>
							</div>
						</CTeleport>
						<keep-alive>
							<component
								ref="childComponent"
								:is="footerComponent"
								v-bind="footerComponentProps"
								@refresh="handleFooterComponentRefresh"
							/>
						</keep-alive>
					</div>
				</div>
			</CScrollPro>
		</transition>

		<div class="footer-teleport-block"></div>
	</div>
</template>

<script>
import CScrollPro from '@/view/enterprise/components/c-scroll-pro.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import CTeleport from '@/view/enterprise/components/c-teleport.vue';
import SmartDisplayC from '@/view/enterprise_rebuild/components/SmartDisplayC.vue';

import BrandFlowOverview from '@rebuild/materials/shared/brand_header/BrandFlowOverview.vue';
import BannerFall from '@rebuild/materials/modules/flow/banner/v1/overview.vue';
import OverviewNews from '@rebuild/materials/modules/flow/news/v1/overview.vue';
import OverviewShareholder from '@rebuild/materials/modules/flow/shareholder/v1/overview.vue';
import OverviewActivity from '@/view/enterprise_rebuild/materials/modules/flow/investment_activity/v1/overview.vue';
import { componentMap as MCalendarMap } from '@rebuild/materials/modules/flow/customs_calendar/v1/index';
// Footer
import FallQuestion from '@rebuild/materials/modules/flow/question/v1/list.vue';
import FallAnnouncement from '@rebuild/materials/modules/flow/announcement/v1/list.vue';
import FallReport from '@rebuild/materials/modules/flow/report/v1/list.vue';
import FallCustom from '@rebuild/materials/modules/flow/custom/v1/list.vue';
import FallNews from '@rebuild/materials/modules/flow/news/v1/list.vue';
import FallUsAnnouncement from '@rebuild/materials/modules/flow/us_announcement/v1/list.vue';
import FallRoadshow from '@rebuild/materials/modules/flow/roadshow/v1/list.vue';
import FallCompanyProfileHK00656 from '@rebuild/materials/modules/flow/company_profile_hk00656/v1/list.vue';

import { throttle } from '@/utils/api';
import { irstore } from '@/fetch/interface';
import BScroll from 'better-scroll';
import { mapGetters } from 'vuex';
import { getLanguageType } from '@/assets/js/i18n';
import { useCommonData } from '@rebuild/hooks/useCommonData';
import { useCoreData } from '@rebuild/hooks/data/useCoreData';
import { useBusEvent } from '@rebuild/hooks/useBusEvent';
import { getCurrentInstance, nextTick, ref } from 'vue';
import { useHeightObserver } from '@rebuild/hooks/useHeightObserver';

const tabComponentMap = {
	'question': FallQuestion,
	'announcement': FallAnnouncement,
	'report': FallReport,
	'news': FallNews,
	'custom': FallCustom,
	'us_announcement': FallUsAnnouncement,

	'roadshow': FallRoadshow,
	'company_profile_hk00656': FallCompanyProfileHK00656,
	'news_hk00656': FallNews
};

let contentList = {
	'question': FallQuestion,
	'announcement': FallAnnouncement,
	'report': FallReport,
	'custom': FallCustom,
	'us_announcement': FallUsAnnouncement,

	'roadshow': FallRoadshow,
	'company_profile_hk00656': FallCompanyProfileHK00656,
	'news_hk00656': FallNews
};
const tabComponentNames = Object.keys(contentList);

export default {
	name: 'enterprise_flow',
	components: {
		CScrollPro,
		CFullEmpty,
		CTeleport,
		SmartDisplayC,

		BannerFall,
		OverviewShareholder,
		BrandFlowOverview,
		OverviewNews,
		OverviewActivity,
		OverviewCalendar: MCalendarMap.overview
	},
	data() {
		return {
			newsList: [],
			tabList: [],

			componentData: {},
			stockholderInfo: {},
			announcementList: [],
			reportFilters: [],
			questionFilters: [],
			actionFilter: [],
			actionFilterValue: '',

			footerActionTabId: '',
			footerComponent: null,
			footerComponentProps: {},

			verticalWrapBS: null,
			configInitDone: false,
			teleportDisabled: true,

			us_announcementList: []
		};
	},
	computed: {
		...mapGetters(['getIrBaseInfo', 'getIrTemplateFlattenModules', 'getPageId']),

		getStoreId() {
			return this.$route.query.storeId;
		},

		storeData() {
			return this.getIrBaseInfo;
		},

		getFullCode() {
			const { code, market } = this.storeData;
			if (code && market) {
				return `${market}${code}`;
			}
			return '';
		},

		// 三方渠道开关控制
		hideModule() {
			return !!this.$bridge.flagship.tabList;
		}
	},
	watch: {
		footerActionTabId(val) {
			const filterMap = {
				'report': 'reportFilters',
				'announcement': 'announcementList',
				'question': 'questionFilters',
				'us_announcement': 'us_announcementList'
			};
			if (val in filterMap) {
				this.actionFilter = this[filterMap[this.footerActionTabId]];
				if (this.actionFilter.length) {
					this.actionFilterValue = this.actionFilter[0].value;
				}
			} else {
				this.actionFilter = [];
			}
		}
	},
	mounted() {
		this.refreshFlowView();
	},
	methods: {
		moduleIsPublish(moduleId) {
			const arr = this.getIrTemplateFlattenModules;
			return arr.some(item => item.moduleId === moduleId);
		},

		resetTemplate() {
			this.footerActionTabId = ''; // 重置选中项, 触发底部菜单刷新
			this.configInitDone = false;
			this.teleportDisabled = true;
		},

		async refreshFlowView() {
			this.resetTemplate();

			await this.processAndSetPageModules();

			this.configInitDone = true;
			this.refreshBScroll();
			this.startContentObs();
		},

		refreshBScroll() {
			this.$nextTick(() => {
				this.$refs.scrollRef?.refresh();
			});
		},

		async processAndSetPageModules() {
			const simplifiedModules = this.getIrTemplateFlattenModules;
			// hide tabs, create tabs
			this.initModules(simplifiedModules);

			// load modules data
			const modulesLoad = [];
			if (this.moduleIsPublish('shareholder')) modulesLoad.push(this.getStockHolders);
			if (this.moduleIsPublish('news')) modulesLoad.push(this.getNewsList);
			await Promise.all(modulesLoad.map(r => r()));
		},

		async scrollPullDown(done) {
			await this.loadIRPageData();
			await this.refreshFlowView();
			done();
			this.refreshBScroll();
		},
		wrapperScroll: throttle(function (pos) {
			const startY = pos.y;
			const boolean = -startY >= this.placeholderTop;
			if (this.placeholderTop <= 300) {
				this.teleportDisabled = true;
				return;
			}
			if (boolean) {
				this.teleportDisabled = false;
			} else {
				this.teleportDisabled = true;
			}
		}, 120),

		createInnerVerticalBS() {
			if (this.verticalWrapBS) {
				this.verticalWrapBS.destroy();
			}
			this.$nextTick(() => {
				if (!this.$refs.verticalWrap) return;
				this.verticalWrapBS = new BScroll(this.$refs.verticalWrap, {
					scrollX: true,
					scrollY: false,
					eventPassthrough: 'vertical',
					momentum: false,
					probeType: 3 // listening scroll event
				});
			});
		},

		async initModules(modules) {
			const filterList = this.getFilterList();
			this.initTabModules(filterList, modules);
			if (!this.hideModule) {
				await this.getFilterLists(modules);

				// action tab child
				this.initTabSelection();
				this.createInnerVerticalBS();
			}
		},
		getFilterList() {
			const filterList = [...tabComponentNames];
			// 普通企业只展示这几个模块，伊利 tab 要多一个新闻
			if (this.isYili) {
				filterList.push('news');
			}
			return filterList;
		},
		initTabModules(filterList, modules) {
			const publishedModules = this.filterPublishedModules(modules, filterList);
			const customModules = this.filterCustomModules(modules);
			if (this.hideModule) {
				this.tabList = [];
			} else {
				this.tabList = this.sortModules(publishedModules, customModules);
			}
		},
		filterPublishedModules(modules, filterList) {
			return modules.filter(item => filterList.includes(item.moduleId));
		},
		filterCustomModules(modules) {
			return modules.filter(module => module.type === 1 && module.isPublish);
		},
		sortModules(publishedModules, customModules) {
			return publishedModules.concat(customModules).sort((a, b) => a.sort - b.sort);
		},

		async getFilterLists(modules) {
			if (modules.some(v => v.moduleId === 'announcement')) {
				await this.getAnnouncementFilterList(modules);
			}
			if (modules.some(v => v.moduleId === 'report')) {
				await this.getReportFilterList(modules);
			}
			if (modules.some(v => v.moduleId === 'question')) {
				await this.getQuestionFilterList(modules);
			}
			if (modules.some(v => v.moduleId === 'us_announcement')) {
				await this.getUsAnnouncementFilterList(modules);
			}
		},
		filterPublishedItems(items) {
			return items.filter(item => item.isPublish).sort((a, b) => a.sort - b.sort);
		},
		getUsAnnouncementFilterList() {
			return this.$axios.get(irstore.getUsAnnouncementType(this.getStoreId), { hideMessage: true }).then(res => {
				this.us_announcementList = (res.data || []).map(v => ({
					text: v,
					value: v
				}));
			});
		},
		getAnnouncementFilterList() {
			return this.$axios
				.get(
					irstore.getModulesTabList(this.getIrBaseInfo.id, this.getPageId, 'announcement'),
					{
						languageType: getLanguageType()
					},
					{ hideMessage: true }
				)
				.then(res => {
					this.announcementList = (res.data || [])
						.sort((a, b) => a.sort - b.sort)
						.filter(v => v.isPublish)
						.map(v => {
							const composeValues =
								v.id != 'announcement_all'
									? [v.id, ...(v.subTabList || []).map(sub => sub.id)]
											.map(v => v.slice(11).replace(/,/g, '#'))
											.join(',')
									: '';
							return {
								text: v.name,
								value: composeValues
							};
						});
				});
		},
		getReportFilterList() {
			return this.$axios
				.get(
					irstore.getModulesTabList(this.getIrBaseInfo.id, this.getPageId, 'report'),
					{
						languageType: getLanguageType()
					},
					{ hideMessage: true }
				)
				.then(res => {
					this.reportFilters = (res.data || [])
						.sort((a, b) => a.sort - b.sort)
						.filter(v => v.isPublish)
						.map(v => {
							const composeValues =
								v.subTabList && v.subTabList.length > 0
									? [v.value, ...v.subTabList.map(sub => sub.value)]
									: v.value;
							return {
								text: v.name,
								value: composeValues
							};
						});
				});
		},
		async getQuestionFilterList() {
			const tabMap = [
				{ text: this.$t('enterprise.QA.tab.enquiry'), value: '5' },
				{ text: this.$t('enterprise.QA.tab.meeting'), value: '1' },
				{ text: this.$t('enterprise.QA.tab.activities'), value: '4' }
			];

			const { market } = this.storeData;
			// 上交所
			if (market === 'sh') {
				tabMap.push({
					text: 'e互动',
					value: '3'
				});
			}
			// 深交所
			if (market === 'sz') {
				tabMap.push({
					text: '互动易',
					value: '3'
				});
			}

			const sources = tabMap.map(v => v.value);
			const promises = sources.map(source => this.fetchQuestionList(source));
			const batchCheckExecute = await Promise.all(promises);

			let renderList = tabMap
				.map((v, idx) => ({
					...v,
					length: batchCheckExecute[idx].length || 0
				}))
				.filter(v => v.length); // 只展示有数据的类型

			if (renderList.length > 1) {
				// renderList.unshift({ text: this.$t('enterprise.all'), value: 'all' });
			} else {
				renderList = []; // 移动端无数据或只有一种类型时，不展示Tab
			}

			this.questionFilters = renderList;
		},
		fetchQuestionList(source) {
			return this.$axios
				.post(irstore.postAdvisoryList, {
					pagestart: 0,
					pagenum: 20,
					fullCode: this.getFullCode,
					sourceBiz: source,
					storeId: this.getStoreId,
					languageType: getLanguageType()
				})
				.then(res => res.rows || [])
				.catch(() => []);
		},

		initTabSelection() {
			if (!this.tabList.length) return;
			this.actionTabComponent(this.tabList[0]);
		},
		selectComponentByCustom(id, coverType) {
			this.footerComponentProps = {
				storeData: this.storeData,
				moduleId: id,
				moduleCoverType: coverType
			};
			this.footerComponent = tabComponentMap['custom'];
			this.refreshComponentData();
		},
		selectComponentByTab(tabId) {
			this.footerComponentProps = {
				storeData: this.storeData
			};
			this.footerComponent = tabComponentMap[tabId] || null;
			this.refreshComponentData();
		},
		async refreshComponentData() {
			await this.$nextTick();
			if (!this.$refs.childComponent) return;
			if (this.$refs.childComponent && this.$refs.childComponent.refreshModule) {
				this.$refs.childComponent.refreshModule({
					value: this.actionFilterValue === 'all' ? '' : this.actionFilterValue,
					actionFilter: this.actionFilter
				});
			}
		},
		handleFooterComponentRefresh() {
			this.refreshBScroll();
		},
		actionTabComponent(item) {
			const { moduleId, type, coverType } = item;
			if (this.footerActionTabId === moduleId) return;
			this.footerActionTabId = moduleId;

			if (moduleId === 'question') {
				this.actionFilterValue = 'all';
			}

			if (type === 1) {
				this.selectComponentByCustom(moduleId, coverType);
			} else {
				this.selectComponentByTab(moduleId);
			}
		},
		footerTabToTop() {
			const isStatic = this.teleportDisabled;
			if (isStatic) return;
			// fixed状态下 Tab点击回滚
			const offsetTop = this.placeholderTop;
			this.$refs.scrollRef?.scrollTo(0, -offsetTop, 300);
		},
		toggleFooterTab(item) {
			this.footerTabToTop();
			this.actionTabComponent(item);
		},
		handleFilterCheck(value) {
			this.footerTabToTop();
			// 正反选
			if (this.actionFilterValue === value) {
				this.actionFilterValue = '';
			} else {
				this.actionFilterValue = value;
			}
			this.refreshComponentData();
		},

		getStockHolders() {
			return this.$axios
				.get(irstore.getShareholderList(this.storeData.market, this.storeData.code), {
					pageStart: 0,
					pageNum: 6,
					languageType: getLanguageType()
				})
				.then(res => {
					const result = res?.data || [];
					const stockholder = {
						date: result.map(item => item.date).reverse(),
						stockholders: result
							.map(item => {
								return (item.totalAccount / 10000).toFixed(2);
							})
							.reverse(),
						price: []
					};

					this.stockholderInfo = stockholder;
				})
				.catch(() => []);
		},
		getNewsList() {
			return this.$axios
				.get(irstore.getNewsList(this.getStoreId), {
					pageStart: 0,
					pageNum: 1,
					languageType: getLanguageType()
				})
				.then(({ data, extra }) => {
					this.newsList = data;
				})
				.catch(() => []);
		},

		async handleIframeMessage(msgData) {
			const { iframePreviewData } = msgData;
			if (iframePreviewData) {
				this.setIRStoreData(iframePreviewData);
				await this.refreshFlowView();
				// Back Top
				this.$nextTick(() => {
					this.$refs.scrollRef?.scrollTo(0, 0, 300);
				});
			}
		}
	},
	setup() {
		const { isYili } = useCommonData();
		const { loadIRPageData, setIRStoreData } = useCoreData();

		const vm = getCurrentInstance();
		useBusEvent('iframe-message', msgData => vm.proxy.handleIframeMessage(msgData));

		const placeholderHeight = ref(0);
		const placeholderTop = ref(0);
		const obPlaceholder = ref(null);
		const teleportWrapper = ref(null);

		// 监听容器高度更新
		const contentBlockRef = ref(null);
		const { start } = useHeightObserver({
			targetRef: contentBlockRef,
			onHeightChange: data => {
				nextTick(() => {
					if (!obPlaceholder.value || !teleportWrapper.value) return;
					placeholderTop.value = obPlaceholder.value.offsetTop;
					placeholderHeight.value = teleportWrapper.value.clientHeight;
				});
			}
		});
		const startContentObs = async () => {
			await nextTick();
			start();
		};

		return {
			isYili,
			loadIRPageData,
			setIRStoreData,

			contentBlockRef,
			startContentObs,
			placeholderHeight,
			placeholderTop,
			obPlaceholder,
			teleportWrapper
		};
	}
};
</script>

<style lang="less" scoped>
.home-flow {
	height: 100%;
}
.wf-wrap-padding {
	padding: 0 0.12rem;
}

.wf-base-overview {
	position: relative;
	background: #ffffff;
	padding-top: 0.59rem;
	padding-bottom: 0.2rem;
	z-index: 10;
}

.wf-card-wrap {
	margin-top: 0.12rem;
	background: #ffffff;
}

.wf-footer-hr {
	height: 0.12rem;
}
.wf-footer-list {
	position: relative;
}
.wf-tab-placeholder {
	position: relative;
}
.wf-tab-teleport {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	background: #ffffff;
}
.footer-teleport-block {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 29;
}

.wf-filter-wrap {
	margin-top: -0.1rem;
	padding: 0.16rem 0 0.16rem 0.12rem;
	display: flex;
	flex-wrap: wrap;

	.wf-filter-item {
		flex-shrink: 0;
		margin: 0.1rem 0.08rem 0 0;
		padding: 0 0.15rem;
		height: 0.27rem;
		background: #f5f5f5;
		border-radius: 0.02rem;

		span {
			font-family: 'PingFang SC';
			font-size: 0.13rem;
			line-height: 0.27rem;
			text-align: center;
		}
		&--active {
			font-weight: 550;
			color: #f76a2b;
		}
	}
}

.tab-sticky-wrapper {
	white-space: nowrap;
	overflow: hidden;
}
.tab-sticky-box {
	position: relative;
	display: inline-flex;
	flex-wrap: nowrap;
	min-width: 100%;

	&::after {
		content: '';
		position: absolute;
		left: -100%;
		right: -100%;
		bottom: 0;
		border-bottom: 1px solid #e8eaef;
	}
	.tab-sticky-item {
		padding: 0 0.12rem;
		height: 0.43rem;
		line-height: 0.43rem;
		flex: 0 0 auto;

		&--active {
			.tab-sticky-value {
				font-weight: 600;
				color: #333;
			}
		}
		// 数量小于等于四个时 宽度按内容自动铺满
		&:nth-child(-n + 4),
		&:nth-last-child(-n + 4) {
			flex: 1 0 auto;
		}
	}
	.tab-sticky-value {
		min-width: 0.6rem;
		font-size: 0.15rem;
		color: #666;
		text-align: center;
	}
}
</style>
